export default {
  side:"prod",
  apiUrl: "https://player.muvika.com/playerapi",
  linkToWebsite: "https://www.muvika.com/site/",
  linkToWebsiteFi: "https://muvika.com/site/fi/",
  iosExternalLinkUrl: "https://www.muvika.com/site/",
  iosExternalLinkUrlTitle: "www.muvika.com/site/",
  externalUrl: "/external",
  basicUrl: "/basic",
  service: "muvika",
  nativeClientHash: "71320747942dc0d63449",
  webClientHash: "18d33cbeb39ca19286dc",
  isProd:true,
  gaID:"AW-954266490",
  gaIDConv:"AW-954266490/WzBXCOT73_oBEPrmg8cD",
  showChooseLang: true
};